import 'jquery-match-height';

$(document).ready(function () {
    $('.eq').matchHeight();
    $('.eq2').matchHeight();
});
